module.exports = __webpack_public_path__ + "img/About_banner_GSJJ.c4cc2204.jpg";